"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesFAB = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "iconName", type: "string", description: "Choose the inner icon by name." }),
    React.createElement(common_1.Property, { name: "color", type: "string", defaultValue: "#da7287", description: "Sets the background color." }),
    React.createElement(common_1.Property, { name: "iconColor", type: "string", description: "Sets the icon color." }))); };
exports.PropertiesFAB.displayName = 'PropertiesFAB';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentFABPage/PropertiesFAB.tsx
// module id = 671
// module chunks = 0